document.addEventListener("latte:init", init);
function init() {
	
	var tableShadow = function(){
       
        $('.js-table-scroll').each(function() {
            if ( $(this).width() > ($( window ).width() - 32 ) ) {
        		id = $(this).attr("id");
            	$("#wrapper"  + id ).addClass("has-scroll");
            }
        });

    };

    tableShadow();

	$(window).resize(function() {
    	tableShadow();
    });
}


$(".inner-table-wrapper").scroll(function() {
    id = $(this).attr("name");
	var leftLocation = $("#" + id).position().left;
	var rightLocation = ($("#" + id).width() - $( window ).width() - 32 );

	if (leftLocation < 0) {
		$("#wrapper"  + id ).addClass("is-scrolling");
	} else {
		$("#wrapper"  + id ).removeClass("is-scrolling");
	}

	if ( rightLocation === leftLocation ) {
		$("#wrapper"  + id ).removeClass("has-scroll");
	} else {
		$("#wrapper"  + id ).addClass("has-scroll");
	}
});






//////////////////
// WEBPACK FOOTER
// ./public/js/table.js
// module id = 92
// module chunks = 0